module.exports = __webpack_public_path__ + "img/logo.f72c51cf.png";